import { createSlice } from '@reduxjs/toolkit'

const DeletedPackageSlice = createSlice({
  name: 'DeletedPackageSlice',
  initialState: [],
  reducers: {
    setDeletedPackages(state, action) {
      return [...action.payload];
    },
    addDeletedPackage(state, action) {
      if (state.some(pkg => pkg.id === action.payload.id)) return state;
      return [...state, action.payload];
    },
    removeDeletedPackage(state, action) {
      return state.filter(pkg => pkg.id !== action.payload.id);
    }
  }
})

export const { setDeletedPackages, addDeletedPackage, removeDeletedPackage } = DeletedPackageSlice.actions
export default DeletedPackageSlice.reducer
